// ABOUTME: API functions for HTML content enhancement operations
// ABOUTME: Typed API calls aligned with backend content enhancement endpoints

/**
 * Request type for content enhancement
 */
export interface IEnhanceContentRequest {
    content: string;
}

/**
 * Response type for content enhancement
 */
export interface IEnhanceContentResponse {
    success: boolean;
    content?: string;
    error?: string;
    message?: string;
}

/**
 * Enhance HTML content using AI
 */
export const enhanceContent = async (content: string): Promise<string> => {
    const response = await fetch('/api/content/enhance', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ content }),
    });

    if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const result: IEnhanceContentResponse = await response.json();

    if (!result.success) {
        throw new Error(result.message || result.error || 'Failed to enhance content');
    }

    if (!result.content) {
        throw new Error('No content returned from enhancement API');
    }

    return result.content;
};
